<template>
  <div class="event-wrapper">
    <t-select
      disabled
      filterable
      placeholder="请选择"
      v-model="formValue.eventName"
      @change="handleEventChange"
      style="width: 208px"
    >
      <t-option
        v-for="item in formOption.eventList"
        :key="item.id"
        :value-key="item.eventName"
        :label="item.eventShowName"
        :value="item.eventName"
      >
        {{ item.eventShowName }}
      </t-option>
    </t-select>

    <div class="connect-text">的</div>

    <select-props
      size="medium"
      v-model="formValue.column"
      :show-total="true"
      :condition-property-options="propertyOption"
      @change="handlePropsChange"
    ></select-props>
  </div>
</template>

<script>
import SelectProps from '@/components/analysis/property-selector.vue';
import { getEventList } from '@/api/analysis/custom-analysis';

export default {
  name: 'associate-property',
  components: {
    SelectProps,
  },
  data() {
    return {
      formOption: {
        eventList: [],
      },
      formValue: {
        eventName: '',
        column: [],
      },
    };
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        eventName: '',
        column: '',
      }),
    },
    eventProps: {
      type: Object,
      default: () => ({
        targetName: '',
        disabled: false,
      }),
    },
    columnProps: {
      type: Object,
      default: () => ({
        targetColumn: {
          type: 'totalCount',
        },
        disabled: false,
      }),
    },

    eventList: {
      type: Array,
      default: () => [],
    },
    propertyOption: {
      type: Array,
      default: () => [],
    },
  },

  created() {
    if (!this.eventList) {
      getEventList({ params: { getType: 'all' } }).then(res => {
        this.formOption.eventList = res || [];
      });
    } else {
      this.formOption.eventList = this.eventList;
    }
    this.formValue = this.value;
  },

  watch: {
    eventList(cur) {
      this.formOption.eventList = cur;
    },
    'value.eventName': function (cur) {
      this.formValue.eventName = cur;
    },
  },

  methods: {
    handleEventChange(event) {
      this.formValue.eventName = event;
      this.$emit('input', this.formValue);
    },

    handlePropsChange() {
      this.$emit('input', this.formValue);
    },
  },
};
</script>

<style lang="less" scoped>
.event-wrapper {
  display: flex;
  flex-direction: row;

  .connect-text {
    line-height: 28px;
    padding: 0 8px;
    font-size: 12px;
  }

  ::v-deep .select-props-container {
    width: 100px;

    .t-popup-reference {
      width: 100px;

      button {
        width: 100px;
        .t-button__text {
          display: flex;
          align-items: center;
          span {
            width: 60px;
            min-width: 60px !important;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
